// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_8Cq","toggleWrap":"styles_toggleWrap__2Wh2U","content":"styles_content__B0NPk","selectAreaCode":"styles_selectAreaCode__2b3AB"};